import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import authService from '../services/authService';
import Dashboard from './Dashboard';
import { isStoreAdmin } from '../utils/storeRoles';

/**
 * Raiz autenticada: administrador vê o dashboard; usuário comum vai para veículos (sem painel financeiro).
 */
const HomeEntry: React.FC = () => {
  const [phase, setPhase] = useState<'loading' | 'ready'>('loading');
  const [admin, setAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await authService.me();
        const role = data?.user?.role;
        if (!cancelled) {
          setAdmin(isStoreAdmin(role));
          setPhase('ready');
        }
      } catch {
        if (!cancelled) {
          setAdmin(false);
          setPhase('ready');
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (phase === 'loading') {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 240,
          gap: 2,
        }}
      >
        <CircularProgress size={48} />
        <Typography variant="body2" color="text.secondary">
          Carregando…
        </Typography>
      </Box>
    );
  }

  if (admin) {
    return <Dashboard />;
  }

  return <Navigate to="/veiculos" replace />;
};

export default HomeEntry;
